var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.42 -0.00463867H4.5C2.01472 -0.00463867 0 2.01008 0 4.49536V34.2654C0 36.7506 2.01472 38.7654 4.5 38.7654H13.42C15.9053 38.7654 17.92 36.7506 17.92 34.2654V4.49536C17.92 2.01008 15.9053 -0.00463867 13.42 -0.00463867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.85 -0.00463867H26.3C23.8148 -0.00463867 21.8 2.01008 21.8 4.49536V12.5954C21.8 15.0806 23.8148 17.0954 26.3 17.0954H34.85C37.3353 17.0954 39.35 15.0806 39.35 12.5954V4.49536C39.35 2.01008 37.3353 -0.00463867 34.85 -0.00463867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.85 21.6753H26.3C23.8148 21.6753 21.8 23.69 21.8 26.1753V34.2753C21.8 36.7606 23.8148 38.7753 26.3 38.7753H34.85C37.3353 38.7753 39.35 36.7606 39.35 34.2753V26.1753C39.35 23.69 37.3353 21.6753 34.85 21.6753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.35,
    height: 38.77,
    fill: "white",
    transform: "translate(0 -0.00463867)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b09aa0a54621c98b7b202c1824067893.svg";
export { ForwardRef as ReactComponent };